(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5828],{

/***/ 65348:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signature/alternatives/docusign-vs-signwell",
      function () {
        return __webpack_require__(67754);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 61050:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

const ListComponent = (param)=>{
    let { title , subTitle , description , list  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "text-gray-900",
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "text-xl font-bold text-gray-900 mb-3",
                children: title
            }),
            subTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "text-lg font-semibold text-gray-900 mb-3",
                children: subTitle
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "text-lg mb-5",
                children: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                className: "ml-10 list-disc text-lg",
                children: list === null || list === void 0 ? void 0 : list.map((para, index)=>{
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                        className: "",
                        children: [
                            (para === null || para === void 0 ? void 0 : para.head) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                className: "font-semibold",
                                children: [
                                    para === null || para === void 0 ? void 0 : para.head,
                                    ": "
                                ]
                            }),
                            (para === null || para === void 0 ? void 0 : para.content) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "",
                                children: para === null || para === void 0 ? void 0 : para.content
                            }),
                            typeof para === "string" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "",
                                children: para
                            })
                        ]
                    }, index);
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ListComponent);


/***/ }),

/***/ 52995:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43138);




const ProductDescription = (param)=>{
    let { heading , headingBig , paragraphs , image , sections , ulHeading , ulImage , ulData , olHeading , olData , conclusionHeading , conclusionParagraphs  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-full",
        children: [
            heading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: "font-bold mb-4 ".concat(headingBig ? "text-2xl sm:text-3xl" : "text-2xl"),
                children: heading
            }),
            paragraphs && paragraphs.map((paragraph, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "text-lg mb-4",
                    children: paragraph
                }, index)),
            image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("figure", {
                className: "relative w-full mb-4 flex flex-col gap-2",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                        src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_3__.BASE_ASSETS_URL, "/v2/alternatives").concat(image.src),
                        width: "10",
                        height: "10",
                        className: "w-full h-auto object-cover border",
                        alt: image === null || image === void 0 ? void 0 : image.alt
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("figcaption", {
                        className: "text-center px-6 sm:px-10 text-xs sm:text-sm italic",
                        children: image === null || image === void 0 ? void 0 : image.caption
                    })
                ]
            }),
            sections === null || sections === void 0 ? void 0 : sections.map((section, index)=>{
                var _section_image, _section_image1;
                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "mb-4",
                    children: [
                        section.heading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            className: "text-xl font-bold mb-2",
                            children: section.heading
                        }),
                        section.paragraphs && section.paragraphs.map((paragraph, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-lg mb-4",
                                children: paragraph
                            }, index)),
                        section.image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("figure", {
                            className: "relative w-full mb-4 flex flex-col gap-2",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_3__.BASE_ASSETS_URL, "/v2/alternatives").concat(section.image.src),
                                    width: "10",
                                    height: "10",
                                    className: "w-full h-auto object-cover border",
                                    alt: (_section_image = section.image) === null || _section_image === void 0 ? void 0 : _section_image.alt
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("figcaption", {
                                    className: "text-center px-6 sm:px-10 text-xs sm:text-sm italic",
                                    children: (_section_image1 = section.image) === null || _section_image1 === void 0 ? void 0 : _section_image1.caption
                                })
                            ]
                        })
                    ]
                }, index);
            }),
            ulHeading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                className: "text-xl font-bold mb-2",
                children: ulHeading
            }),
            ulImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("figure", {
                className: "relative w-full mb-4 flex flex-col gap-2",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                        src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_3__.BASE_ASSETS_URL, "/v2/alternatives").concat(ulImage.src),
                        width: "10",
                        height: "10",
                        className: "w-full h-auto object-cover border",
                        alt: ulImage === null || ulImage === void 0 ? void 0 : ulImage.alt
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("figcaption", {
                        className: "text-center px-6 sm:px-10 text-xs sm:text-sm italic",
                        children: ulImage === null || ulImage === void 0 ? void 0 : ulImage.caption
                    })
                ]
            }),
            ulData && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                className: "list-disc pl-6 mb-4 text-gray-900",
                children: ulData.map((data, index)=>{
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                        className: "text-lg",
                        children: [
                            (data === null || data === void 0 ? void 0 : data.title) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("strong", {
                                children: [
                                    data.title,
                                    ": "
                                ]
                            }),
                            data === null || data === void 0 ? void 0 : data.description
                        ]
                    }, index);
                })
            }),
            olHeading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                className: "text-xl font-bold mb-2",
                children: olHeading
            }),
            olData && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ol", {
                className: "list-decimal pl-6 mb-4 text-gray-900",
                children: olData.map((data, index)=>{
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                        className: "text-lg",
                        children: [
                            (data === null || data === void 0 ? void 0 : data.title) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("strong", {
                                children: [
                                    data.title,
                                    ": "
                                ]
                            }),
                            data === null || data === void 0 ? void 0 : data.description
                        ]
                    }, index);
                })
            }),
            conclusionHeading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                className: "text-2xl font-bold mb-2",
                children: conclusionHeading
            }),
            conclusionParagraphs && conclusionParagraphs.map((paragraph, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "text-lg mb-4",
                    children: paragraph
                }, index))
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ProductDescription);


/***/ }),

/***/ 67754:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ docusign_vs_signwell; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/ComparisonTable/index.jsx
var ComparisonTable = __webpack_require__(66143);
// EXTERNAL MODULE: ./components/StickyLoginCard/index.jsx
var StickyLoginCard = __webpack_require__(46591);
// EXTERNAL MODULE: ./components/BlogImgAndTitle/index.jsx
var BlogImgAndTitle = __webpack_require__(50369);
// EXTERNAL MODULE: ./constants/constants.js
var constants = __webpack_require__(43138);
;// CONCATENATED MODULE: ./components/v2/Alternatives/AlternativeImages.jsx




const AlternativeImages = (param)=>{
    let { image  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", {
        className: "relative w-full mb-4 flex flex-col gap-2",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: "".concat(constants.BASE_ASSETS_URL, "/v2/alternatives").concat(image.src),
                width: "10",
                height: "10",
                className: "w-full h-auto object-cover border",
                alt: image === null || image === void 0 ? void 0 : image.alt
            }),
            (image === null || image === void 0 ? void 0 : image.caption) && /*#__PURE__*/ (0,jsx_runtime.jsx)("figcaption", {
                className: "text-center px-6 sm:px-10 text-xs sm:text-sm italic",
                children: image === null || image === void 0 ? void 0 : image.caption
            })
        ]
    });
};
/* harmony default export */ var Alternatives_AlternativeImages = (AlternativeImages);

// EXTERNAL MODULE: ./components/v2/Alternatives/ProductDescription.jsx
var ProductDescription = __webpack_require__(52995);
// EXTERNAL MODULE: ./components/v2/Alternatives/ListComponent.jsx
var ListComponent = __webpack_require__(61050);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
;// CONCATENATED MODULE: ./pages/signature/alternatives/docusign-vs-signwell.jsx












const comparisonInfoData = {
    title: "DocuSign vs. SignWell: Key Features Comparison",
    desc: "Let us compare DocuSign and SignWell in a tabular form based on key features and considerations:"
};
const comparisonTableData = [
    {
        id: 0,
        feature: "Feature/Consideration",
        alternative1: "DocuSign",
        alternative2: "SignWell"
    },
    {
        id: 1,
        feature: "Esign",
        alternative1: "Well-established e-signature solution.",
        alternative2: "User-friendly electronic signature software."
    },
    {
        id: 2,
        feature: "Suitable For",
        alternative1: "Companies of all sizes and industries.",
        alternative2: "Small businesses, startups, solo entrepreneurs."
    },
    {
        id: 3,
        feature: "Document Types",
        alternative1: "All types of documents.",
        alternative2: "Various file types, including PDFs."
    },
    {
        id: 4,
        feature: "Custom Templates",
        alternative1: "Yes, customizable templates.",
        alternative2: "Customizable templates for quick document setup."
    },
    {
        id: 5,
        feature: "Scalability",
        alternative1: "Highly scalable, ideal for enterprises.",
        alternative2: "May have limitations in enterprise scalability."
    },
    {
        id: 6,
        feature: "Free Plan",
        alternative1: "Offers a free plan with basic features.",
        alternative2: "Provides a free plan for users."
    },
    {
        id: 7,
        feature: "Free Trial",
        alternative1: "Offers a free 30-day trial period.",
        alternative2: "No free trial option is available."
    },
    {
        id: 8,
        feature: "Industry Focus",
        alternative1: "Versatile, with industry-specific plans.",
        alternative2: "Broad industry focus may lack industry-specific features."
    },
    {
        id: 9,
        feature: "Pricing",
        alternative1: "Generally more expensive.",
        alternative2: "Cost-effective alternative to DocuSign."
    }
];
const comparisonData = [
    {
        id: 1,
        comparePoint: "Esignature",
        introPara: "Lets summarize the comparison between DocuSign and SignWell based on their e-signature capabilities:",
        alternative1Heading: "DocuSign:",
        alternative1ListComponentData: [
            {
                desc: "Widely recognized and compliant with international eSignature laws."
            },
            {
                desc: "Scalable for enterprises and offers specialized industry plans."
            },
            {
                desc: "Extensive customization options for templates and workflows."
            },
            {
                desc: "Advanced features for complex signing processes."
            },
            {
                desc: "Seamless integration with third-party applications."
            }
        ],
        alternative2Heading: "SignWell:",
        alternative2ListComponentData: [
            {
                desc: "Known for its user-friendly interface."
            },
            {
                desc: "Customizable templates for streamlined signing processes."
            },
            {
                desc: "Real-time document tracking for monitoring."
            },
            {
                desc: "Compliant with eSignature laws and focused on security."
            },
            {
                desc: "Cost-effective pricing suitable for small businesses."
            }
        ]
    },
    {
        id: 2,
        comparePoint: "Suitable For",
        introPara: "Lets compare DocuSign and SignWell based on who they are most suitable for:",
        alternative1Heading: "DocuSign:",
        alternative1ListComponentData: [
            {
                title: "Enterprise-Level",
                desc: "DocuSign is highly suitable for enterprises and large organizations with complex document-signing processes. It scales effectively to meet the demands of larger businesses."
            },
            {
                title: "All Industries",
                desc: "It caters to a broad spectrum of industries, including finance, healthcare, real estate, and more. DocuSign offers specialized plans for specific sectors, such as real estate-focused plans."
            },
            {
                title: "Budget Flexibility",
                desc: "While DocuSign can be more expensive, it provides comprehensive features and customization options suitable for businesses willing to invest in an e-signature solution."
            }
        ],
        alternative2Heading: "SignWell:",
        alternative2ListComponentData: [
            {
                title: "Small Businesses",
                desc: "SignWell is an excellent choice for small businesses, startups, and sole proprietors looking for a cost-effective e-signature solution. Its pricing is budget-friendly."
            },
            {
                title: "User-Friendly",
                desc: "SignWells user-friendly interface makes it accessible to users with varying levels of technical expertise, making it ideal for those who may not be tech-savvy."
            },
            {
                title: "Efficiency",
                desc: "It offers customizable templates and real-time document tracking, making it efficient for businesses with straightforward document signing needs."
            }
        ]
    },
    {
        id: 3,
        comparePoint: "Document Types",
        introPara: "Lets compare DocuSign and SignWell based on the types of documents they support:",
        alternative1Heading: "DocuSign:",
        alternative1ListComponentData: [
            {
                title: "Versatile Document Support",
                desc: "DocuSign is known for its versatility in supporting various types of documents. It can handle a wide range of document types, making it suitable for almost any industry or use case."
            },
            {
                title: "Industry-Specific Documents",
                desc: "DocuSign offers specialized plans with features tailored to specific industries, such as real estate. This means it can accommodate industry-specific documents and requirements effectively."
            }
        ],
        alternative2Heading: "SignWell:",
        alternative2ListComponentData: [
            {
                title: "Varied File Types",
                desc: "SignWell supports various file types, including PDFs, which are commonly used for document signing. It provides flexibility for users working with different document formats."
            },
            {
                title: "Customizable Templates",
                desc: "SignWell allows users to create and customize templates for frequently used documents, streamlining the signing process for specific document types."
            }
        ]
    },
    {
        id: 4,
        comparePoint: "Custom Templates",
        introPara: "Lets compare DocuSign and SignWell based on the custom templates they provide:",
        alternative1Heading: "DocuSign:",
        alternative1ListComponentData: [
            {
                title: "Extensive Template Customization",
                desc: "DocuSign offers extensive customization options for document templates. Users can create templates that suit their specific needs and branding."
            },
            {
                title: "Templates for Various Industries",
                desc: "DocuSign provides industry-specific templates, making it easier for businesses in sectors like real estate to streamline their document workflows."
            },
            {
                title: "Advanced Template Features",
                desc: "It offers advanced template features such as conditional fields and formula fields, allowing for highly customized and dynamic templates."
            }
        ],
        alternative2Heading: "SignWell:",
        alternative2ListComponentData: [
            {
                title: "Customizable Templates",
                desc: "SignWell allows users to create and customize templates for frequently used documents. This feature streamlines the document signing process and saves time."
            },
            {
                title: "User-Friendly Template Editor",
                desc: "SignWells user-friendly interface makes it accessible for users with varying levels of technical expertise to create and modify templates."
            }
        ]
    },
    {
        id: 5,
        comparePoint: "Scalability",
        introPara: "Lets compare DocuSign and SignWell based on their scalability:",
        alternative1Heading: "DocuSign:",
        alternative1ListComponentData: [
            {
                title: "Enterprise-Ready",
                desc: "DocuSign is highly scalable and designed to meet the needs of large enterprises and organizations with complex document signing processes. It can handle a high volume of documents and users."
            },
            {
                title: "Industry-Specific Plans",
                desc: "DocuSign offers specialized plans for various industries, such as real estate and healthcare, allowing it to scale and adapt to the unique requirements of different sectors."
            },
            {
                title: "Customization for Scalability",
                desc: "With its advanced features and customization options, DocuSign can be tailored to suit the scalability needs of businesses, making it suitable for both small and large enterprises."
            }
        ],
        alternative2Heading: "SignWell:",
        alternative2ListComponentData: [
            {
                title: "Limitations in Enterprise Scalability",
                desc: "SignWell may have limitations in terms of enterprise scalability. While it is user-friendly and cost-effective, it may not be the ideal choice for large organizations with extensive document signing needs."
            },
            {
                title: "Focus on Small Businesses",
                desc: "SignWell is primarily designed for small businesses, startups, and solo entrepreneurs, making it a suitable choice for those with modest scalability requirements."
            }
        ]
    },
    {
        id: 6,
        comparePoint: "Industry Focus",
        introPara: "Lets compare DocuSign and SignWell based on their industry focus:",
        alternative1Heading: "DocuSign:",
        alternative1ListComponentData: [
            {
                title: "Versatile Across Industries",
                desc: "DocuSign is versatile and caters to a wide range of industries, making it suitable for businesses in finance, healthcare, real estate, legal, and many other sectors."
            },
            {
                title: "Industry-Specific Plans",
                desc: "DocuSign offers specialized plans tailored to specific industries, such as real estate. These plans come with industry-specific features to meet unique requirements."
            },
            {
                title: "Real Estate Focus",
                desc: 'DocuSign offers specialized plans like "DocuSign for REALTORS" and "Real Estate" plans, designed to address the specific needs of real estate professionals. These plans include tools for transaction management and remote online notarization.'
            }
        ],
        alternative2Heading: "SignWell (Industry Focus):",
        alternative2ListComponentData: [
            {
                title: "Broad Industry Focus",
                desc: "SignWell does not have a specific industry focus and is designed to cater to a broad range of users and small businesses in various industries."
            }
        ],
        outroPara: "In summary, DocuSign stands out for its versatile industry focus, serving a wide array of sectors and offering specialized plans with industry-specific features. SignWell, while suitable for a broad range of users, does not have the same level of industry-specific specialization. Your choice between the two should consider your specific industry needs and whether you require industry-specific features in your e-signature solution."
    },
    {
        id: 7,
        comparePoint: "Pricing Plans",
        introPara: "To help you make an informed decision, lets delve into the pricing plans offered by SignWell and DocuSign:",
        alternative1Heading: "DocuSign:",
        alternative1Img: {
            url: "docusign-pricing.png",
            altText: "DocuSign Price and Plans"
        },
        alternative1ListComponentData: [
            {
                title: "Personal Plan",
                desc: "Priced at $120 per year or $15 per month, it offers five signature requests and includes one user. You also get features like reusable templates, a real-time audit log, a mobile app, and more."
            },
            {
                title: "Standard Plan",
                desc: "Costing $300 per user per year or $45 per user per month, this plan provides unlimited signature requests and all features from the Personal plan. It adds shared templates, shared documents, team reports, comments, in-person eSignatures, and more."
            },
            {
                title: "Business Pro Plan",
                desc: "Priced at $480 per user per year or $65 per user per month, this plan includes all Standard plan features. It offers SMS authentication, collaborative fields, signer attachments, bulk send, drawing fields, collect payments, and more."
            },
            {
                title: "Enhanced Plans",
                desc: "Tailored for larger companies, these custom plans include all features from the Business Pro plan, along with APIs, identification and authentication, embedded signing, and more."
            },
            {
                title: "Real Estate Plans",
                desc: "DocuSign offers specialized plans for the real estate industry, such as Real Estate Starter, DocuSign for REALTORS, Real Estate, and Enhanced Real Estate Brokerage plans. These plans feature industry-specific tools like a transaction platform and remote online notarization."
            }
        ],
        alternative1OutroPara1: "In addition, DocuSign provides a free plan with limited signature requests and basic features, suitable for users starting with e-signatures.",
        alternative2Heading: "SignWell:",
        alternative2Img: {
            url: "signwell-pricing.png",
            altText: "SignWell Price and Plans"
        },
        alternative2ListComponentData: [
            {
                title: "Free Plan",
                desc: "Ideal for those starting out, it includes one user, one template, and three signature requests per month, along with reminders and notifications."
            },
            {
                title: "Personal Plan",
                desc: "Priced at $96 per year or $10 per month, this plan offers one user, five templates, and unlimited signature requests. It also includes advanced features like template links, bulk send, and advanced preferences."
            },
            {
                title: "Business Plan",
                desc: "At $288 per year or $30 per month, it caters to businesses with three users, unlimited templates, and signature requests. It provides custom branding, data validation, request attachments, in-person signing, and more. Additional users cost $96 per user per year or $10 per user per month."
            },
            {
                title: "API & Enterprise Plan",
                desc: "Designed for larger companies, this custom plan offers all features from the Business plan, along with API access, dedicated support, custom plans, advanced features, and more. You can obtain a quote from the sales team."
            }
        ]
    }
];
const HowBoloSignIsDifferent = {
    heading: "How Is BoloSign Different From The Other Players In The Market?",
    headingBig: true,
    image: {
        src: "/bolosign.png",
        alt: "BoloSign eSignature platform for small businesses with unlimited signatures, templates, and forms",
        caption: "BoloSign: AI for Smart Contract Management. Unlimited signatures, templates, forms, and team members at one fixed price."
    },
    paragraphs: [
        "If you're seeking an e-signature solution that's both user-friendly like SignWell and budget-friendly like DocuSign, BoloForms is a perfect choice. Unlike DocuSign and SignWell, you can jump right in with a free account on BoloForms. With the free account, you can send up to 50 form responses while getting signature requests per month. Need more flexibility? For just $10 per month, BoloForms unlocks 100 form signature requests, enabling you to send 5 documents per month, which is cheaper compared to the other two and is a great option for small businesses. "
    ],
    sections: [
        {
            heading: "Pricing and Value",
            paragraphs: [
                "BoloSign offers a fixed-price model with unlimited signatures, templates, forms, and team members. This makes it highly cost-effective, especially for small businesses, as it's up to 90% cheaper than DocuSign."
            ]
        },
        {
            heading: "Features and Usability",
            paragraphs: [
                "BoloSign is designed with a simple, intuitive interface requiring no technical skills. It offers unlimited usage, customization options, and features for easy collaboration and real-time updates."
            ]
        },
        {
            heading: "Target Audience",
            paragraphs: [
                "BoloSign is specifically designed for small businesses, offering a comprehensive solution at an affordable price."
            ]
        },
        {
            heading: "Integration and Compatibility",
            paragraphs: [
                "BoloSign integrates with popular applications like Google Drive, Dropbox, and CRM systems. It's designed for easy document upload and management without requiring technical skills."
            ]
        },
        {
            heading: "Security and Compliance",
            image: {
                src: "/bolosign-security-compliance.png",
                caption: "How BoloSign Stands Out: Pricing and Value, Features and Usability, Target Audience, Integration, Security.",
                alt: "BoloSign's unique features: Pricing, Usability, Audience, Integration, Security."
            },
            paragraphs: [
                "BoloSign provides enterprise-grade security features and compliance with international eSignature laws, ensuring document safety and legality."
            ]
        }
    ],
    conclusionParagraphs: [
        "Distinguishing itself from other solutions like DocuSign and SignWell, BoloForms offers a swift and streamlined platform that gets you started effortlessly. Creating online documents with BoloForms is a breeze. Start by specifying whether you need to sign the document or not. Then, name your document, import it, or create it using the built-in editor, and designate the signers and the display message to accompany it.",
        "You can even set the order in which signers receive the document and review it before sending it to ensure everything is in order. Once you hit send, BoloForms guides your signers through the entire signature process, allowing them to create their own signature if needed. Begin your BoloForms journey by signing up for free today!"
    ]
};
const ComparingDocusignAndSignwell = {
    title: "Comparing DocuSign and SignWell’s Pricing Plans",
    DocuSign: {
        subTitle: "DocuSign",
        list: [
            {
                head: "Personal Plan",
                content: "$120/year or $15/month, includes five signature requests, reusable templates, and a mobile app."
            },
            {
                head: "Standard Plan",
                content: "$300/user/year or $45/user/month, offers unlimited signature requests, shared templates, team reports, and more."
            },
            {
                head: "Business Pro Plan",
                content: "$480/user/year or $65/user/month, includes SMS authentication, collaborative fields, bulk send, and more."
            },
            {
                head: "Enhanced Plans",
                content: "Custom plans for larger companies with additional features like APIs and embedded signing."
            },
            {
                head: "Real Estate Plans",
                content: "Specialized plans for the real estate industry with tools like transaction platforms and remote online notarization."
            }
        ]
    },
    SignWell: {
        subTitle: "SignWell",
        list: [
            {
                head: "Free Plan",
                content: "One user, one template, and three signature requests per month."
            },
            {
                head: "Personal Plan",
                content: "$96/year or $10/month, includes one user, five templates, and unlimited signature requests."
            },
            {
                head: "Business Plan",
                content: "$288/year or $30/month, for three users with unlimited templates and signature requests."
            },
            {
                head: "API & Enterprise Plan",
                content: "Custom plan with API access, dedicated support, and advanced features."
            }
        ]
    }
};
const KeyFeatures = {
    title: "Key Features of SignWell vs. DocuSign",
    SignWell: {
        heading: "SignWell",
        image: {
            src: "/signwell-key-features.png",
            alt: "Key Features of SignWell: User-Friendly Interface, Customizable Templates, Real-Time Tracking, Cost-Effective, Integration, Security.",
            caption: "Key Features of SignWell: User-Friendly Interface, Customizable Templates, Real-Time Document Tracking, Cost-Effective Pricing, Integration Capabilities, and Security and Compliance."
        },
        sections: [
            {
                heading: "User-Friendly Interface",
                paragraphs: [
                    "SignWell is known for its intuitive and straightforward interface, making it easy for users of all technical levels to navigate and use effectively."
                ]
            },
            {
                heading: "Customizable Templates",
                paragraphs: [
                    "Users can create and customize templates for frequently used documents, streamlining the signing process and saving time."
                ]
            },
            {
                heading: "Real-Time Document Tracking",
                paragraphs: [
                    "SignWell offers real-time tracking of documents, allowing users to monitor the status of signatures and follow up as needed."
                ]
            },
            {
                heading: "Cost-Effective Pricing",
                paragraphs: [
                    "SignWell provides budget-friendly pricing plans, making it an excellent choice for small businesses and startups."
                ]
            },
            {
                heading: "Integration Capabilities",
                paragraphs: [
                    "It integrates with over 5,000 applications, including popular platforms like Gmail, Dropbox, and Slack, enhancing workflow efficiency."
                ]
            },
            {
                heading: "Security and Compliance",
                paragraphs: [
                    "SignWell complies with US and international eSignature laws, ensuring that all signatures are legally binding and secure."
                ]
            }
        ]
    },
    Docusign: {
        heading: "DocuSign",
        image: {
            src: "/docusign-key-features.png",
            alt: "Key features of DocuSign: Scalability, Environmental Initiatives, Third-Party Apps, Security, and Industry Solutions.",
            caption: "Key Features of DocuSign: Scalability, Environmental Initiatives, Third-Party Applications, Security & Compliance, Industry-Specific Solutions, Advanced Customization."
        },
        sections: [
            {
                heading: "Advanced Customization",
                paragraphs: [
                    "DocuSign offers extensive customization options for templates and workflows, including conditional fields and formula fields for dynamic templates."
                ]
            },
            {
                heading: "Scalability",
                paragraphs: [
                    "Designed to meet the needs of large enterprises, DocuSign can handle a high volume of documents and users, making it suitable for complex signing processes."
                ]
            },
            {
                heading: "Industry-Specific Solutions",
                paragraphs: [
                    "DocuSign provides specialized plans tailored to various industries such as real estate, healthcare, and finance, offering tools and features specific to each sector."
                ]
            },
            {
                heading: "Security and Compliance",
                paragraphs: [
                    "DocuSign meets stringent global security certifications and compliance standards, including advanced and qualified electronic signatures (AES and QES) under EU eIDAS."
                ]
            },
            {
                heading: "Integration with Third-Party Applications",
                paragraphs: [
                    "It seamlessly integrates with numerous third-party applications and offers APIs for custom integrations, enhancing its versatility."
                ]
            },
            {
                heading: "Advanced Features",
                paragraphs: [
                    "DocuSign includes advanced features like identity verification, bulk send, and payment collection, which are beneficial for businesses with complex requirements."
                ]
            },
            {
                heading: "Environmental Initiatives",
                paragraphs: [
                    "DocuSign promotes environmental sustainability through its DocuSign for Forests initiative, helping reduce paper usage and carbon footprint."
                ]
            }
        ]
    }
};
const DocusignVsSignWell = ()=>{
    var _ComparingDocusignAndSignwell_DocuSign, _ComparingDocusignAndSignwell_DocuSign1, _ComparingDocusignAndSignwell_SignWell, _ComparingDocusignAndSignwell_SignWell1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full md:mt-20 mt-8",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        charSet: "utf-8"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "DocuSign vs SignWell: Which eSignature Solution Fits Your Business?"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "Compare DocuSign and SignWell features, pricing, and more to find the best eSignature solution for your business needs."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "geo.region",
                        content: "IN"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "geo.position",
                        content: "22.351115;78.667743"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "ICBM",
                        content: "22.351115, 78.667743"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "author",
                        content: "Boloforms"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "publisher",
                        content: "BoloForms"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "keywords",
                        content: "DocuSign, SignWell vs DocuSign, SignWell and DocuSign or SignWell, E-Signature Solutions, Electronic Signatures, Digital Transformation, Document Management, Electronic Signature Comparison, Business, Small Business"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: "https://www.bolosign.com/signature/alternatives/docusign-vs-signwell/"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: "DocuSign vs SignWell: Which eSignature Solution Fits Your Business?"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:site",
                        content: "@boloforms"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:url",
                        content: "https://www.bolosign.com/signature/alternatives/docusign-vs-signwell/"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: "DocuSign vs SignWell: Which eSignature Solution Fits Your Business?"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:creator",
                        content: "@boloforms"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:domain",
                        content: "https://bolosign.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "robots",
                        content: "INDEX, FOLLOW, MAX-IMAGE-PREVIEW:LARGE, MAX-SNIPPET:-1, MAX-VIDEO-PREVIEW:-1"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.bolosign.com/signature/alternatives/docusign-vs-signwell/"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-w-screen-xl md:px-8 px-4 mx-auto flex flex-col mb-20",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mx-auto relative w-full h-fit sm:h-[400px] lg:h-[500px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            className: "w-full h-full sm:h-[400px] lg:h-[500px] object-cover rounded-3xl rounded-b-3xl",
                            src: "".concat(constants.BASE_ASSETS_URL, "/v2/alternatives/docusign-vs-signwell.png"),
                            width: 10,
                            height: 10,
                            alt: "DocuSign vs Signwell comparison graphic."
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col gap-y-16 lg:flex-row-reverse justify-between mt-[50px] sm:mt-[100px] lg:gap-12 xxl:gap-40",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "self-center lg:self-start lg:sticky lg:top-[120px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyLoginCard/* default */.Z, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col gap-4",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                className: "font-bold text-3xl sm:text-4xl text-black",
                                                children: "DocuSign vs. SignWell: A Comprehensive Comparison for Your E-Signature Needs"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-lg text-gray-900",
                                                children: "In today's fast-paced digital world, handling document signatures has transformed significantly. Electronic signature (e-signature) solutions have become the go-to for businesses and individuals who want a faster, more convenient way to sign documents. With so many options available, it can be tough to decide which e-signature platform is best for your needs. Let's dive into a comparison of two prominent e-signature solutions: DocuSign and SignWell. We'll explore their features, usability, and pricing to help you make an informed decision."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col gap-4 mt-4 sm:mt-8",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                className: "font-bold text-2xl text-black mt-10",
                                                children: "DocuSign Overview"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Alternatives_AlternativeImages, {
                                                image: {
                                                    src: "/docusign-overview.png",
                                                    alt: "DocuSign IAM Applications designed to fit every team.",
                                                    caption: "Explore DocuSign IAM Applications: Tailored Solutions for Every Team"
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-lg text-gray-900",
                                                children: "DocuSign is a leading digital signature software designed to streamline the process of signing documents online. This web-based platform allows you to create digital signatures, upload documents, and sign them digitally. If your documents need multiple signatories, DocuSign makes it easy to collect their signatures efficiently. By incorporating DocuSign into your workflow, you can save valuable time, effort, and resources."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                className: "font-bold text-2xl text-black mt-6 sm:mt-8",
                                                children: "Pros and Cons of DocuSign:"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-lg font-medium italic",
                                                children: "Pros:"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                className: "ml-10 list-disc text-lg",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        className: "mb-2",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "text-lg text-gray-900",
                                                            children: "Highly scalable for enterprise-level operations."
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        className: "mb-2",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "text-lg text-gray-900",
                                                            children: "Offers a free plan for users."
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        className: "mb-2",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "text-lg text-gray-900",
                                                            children: "Provides a free 30-day trial period for exploration."
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-lg text-black font-medium italic",
                                                children: "Cons:"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                className: "ml-10 list-disc text-lg",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: "mb-2",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "text-lg text-gray-900",
                                                        children: "Generally more expensive than SignWell."
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "text-lg text-gray-900",
                                                children: [
                                                    "While DocuSign excels in scalability and offers free usage options, its pricing may be a consideration for budget-conscious customers, especially when compared to more cost-effective solutions like SignWell or",
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "cursor-pointer underline text-violet-600",
                                                        onClick: ()=>window.open("https://www.boloforms.com/signature/", "_blank"),
                                                        children: "BoloForms"
                                                    }),
                                                    "."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                className: "font-bold text-2xl text-black mt-6 sm:mt-8",
                                                children: "SignWell Overview"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Alternatives_AlternativeImages, {
                                                image: {
                                                    src: "/signwell-overview.png",
                                                    alt: "SignWell simplifies document signing and cuts turnaround time in half.",
                                                    caption: "SignWell: Simplify Your Document Signing and Cut Turnaround Time in Half"
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-lg text-gray-900",
                                                children: "SignWell is a cloud-based electronic signature solution catering to a wide range of industries, including legal, education, HR, sales automation, IT, and more. While it may be newer in the field compared to DocuSign, SignWell packs all the essential features needed to streamline your document workflow. With SignWell, you can effortlessly create digital signatures, upload documents, sign them electronically, and gather signatures from others."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                className: "font-bold text-2xl text-black mt-6 sm:mt-8",
                                                children: "Pros and Cons of SignWell:"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-lg font-medium italic",
                                                children: "Pros:"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                className: "ml-10 list-disc text-lg",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        className: "mb-2",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "text-lg text-gray-900",
                                                            children: "Cost-effective alternative to DocuSign."
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        className: "mb-2",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "text-lg text-gray-900",
                                                            children: "Offers a free plan for users."
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-lg text-black font-medium italic",
                                                children: "Cons:"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                className: "ml-10 list-disc text-lg",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        className: "mb-2",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "text-lg text-gray-900",
                                                            children: "Limited scalability for enterprise needs."
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        className: "mb-2",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "text-lg text-gray-900",
                                                            children: "No provision for a free trial period."
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-lg text-gray-900",
                                                children: "While SignWell presents cost-saving advantages and a user-friendly free plan, its crucial to weigh its suitability for enterprise-scale operations and the absence of a free trial when considering it as your electronic signature solution."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ComparisonTable/* default */.Z, {
                                        comparisonInfoData: comparisonInfoData,
                                        comparisonTableData: comparisonTableData
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col gap-4 mt-10 sm:mt-16",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                className: "font-bold text-3xl text-black",
                                                children: KeyFeatures.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDescription/* default */.Z, {
                                                ...KeyFeatures.SignWell
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDescription/* default */.Z, {
                                                ...KeyFeatures.Docusign
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "w-full mt-10 sm:mt-16 flex flex-col gap-4",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                className: "font-bold text-3xl text-black",
                                                children: ComparingDocusignAndSignwell === null || ComparingDocusignAndSignwell === void 0 ? void 0 : ComparingDocusignAndSignwell.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListComponent/* default */.Z, {
                                                subTitle: ComparingDocusignAndSignwell === null || ComparingDocusignAndSignwell === void 0 ? void 0 : (_ComparingDocusignAndSignwell_DocuSign = ComparingDocusignAndSignwell.DocuSign) === null || _ComparingDocusignAndSignwell_DocuSign === void 0 ? void 0 : _ComparingDocusignAndSignwell_DocuSign.subTitle,
                                                list: ComparingDocusignAndSignwell === null || ComparingDocusignAndSignwell === void 0 ? void 0 : (_ComparingDocusignAndSignwell_DocuSign1 = ComparingDocusignAndSignwell.DocuSign) === null || _ComparingDocusignAndSignwell_DocuSign1 === void 0 ? void 0 : _ComparingDocusignAndSignwell_DocuSign1.list
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListComponent/* default */.Z, {
                                                subTitle: ComparingDocusignAndSignwell === null || ComparingDocusignAndSignwell === void 0 ? void 0 : (_ComparingDocusignAndSignwell_SignWell = ComparingDocusignAndSignwell.SignWell) === null || _ComparingDocusignAndSignwell_SignWell === void 0 ? void 0 : _ComparingDocusignAndSignwell_SignWell.subTitle,
                                                list: ComparingDocusignAndSignwell === null || ComparingDocusignAndSignwell === void 0 ? void 0 : (_ComparingDocusignAndSignwell_SignWell1 = ComparingDocusignAndSignwell.SignWell) === null || _ComparingDocusignAndSignwell_SignWell1 === void 0 ? void 0 : _ComparingDocusignAndSignwell_SignWell1.list
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col gap-4 mt-10 sm:mt-16",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                className: "font-bold text-3xl text-black",
                                                children: "Choosing Between DocuSign and SignWell For Your Business"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-lg text-gray-900",
                                                children: "DocuSign and SignWell both offer e-signature solutions suitable for small businesses and the choice depends on specific needs:"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                className: "ml-10 list-decimal text-lg",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                        className: "mb-2",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "text-lg font-medium",
                                                                children: "DocuSign"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "text-lg text-gray-900",
                                                                children: ": Its a well-established, feature-rich platform with a strong reputation for reliability and integrations. DocuSign is ideal for businesses with complex signing workflows and a need for extensive customization."
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                        className: "mb-2",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "text-lg font-medium",
                                                                children: "SignWell"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "text-lg text-gray-900",
                                                                children: ": SignWell is a more budget-friendly option, known for its simplicity and ease of use. It may be a good fit for small businesses looking for a straightforward e-signature solution without advanced features."
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-lg text-gray-900",
                                                children: "Consider your business requirements, budget, and preferences when deciding between the two."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mt-10 sm:mt-16",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDescription/* default */.Z, {
                                            ...HowBoloSignIsDifferent
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col gap-4 mt-16",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                className: "font-bold text-3xl text-black",
                                                children: "Conclusion"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "text-lg text-gray-900",
                                                children: [
                                                    "In summary, this article examined SignWell and DocuSigns digital signature solutions, covering features, integrations, security, use cases, ease of use, pricing, and customer feedback.",
                                                    " "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "text-lg text-gray-900",
                                                children: [
                                                    "In conclusion, SignWell is cost-effective and ideal for sole proprietors and small businesses. DocuSign offers robust scalability, making it a better fit for larger enterprises.",
                                                    " "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "text-lg text-gray-900",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "cursor-pointer underline text-violet-600",
                                                        onClick: ()=>window.open("https://www.boloforms.com/signature/", "_blank"),
                                                        children: "BoloForms"
                                                    }),
                                                    " ",
                                                    "offers a compelling alternative with its intuitive interface, robust features, and cost-effective pricing, combining the strengths of both SignWell and DocuSign. Its worth considering in your search for an ideal e-signature solution."
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var docusign_vs_signwell = (DocusignVsSignWell);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,6721,9774,2888,179], function() { return __webpack_exec__(65348); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);